import { type Messages } from ".";

export const messagesDE: Messages = {
  HOME: {
    TITLE: "Übersicht",
    ROUTE: "/dashboard",
    PAGE: "Willkommen bei DASF",
    INTRO:
      "Ein leistungsstarkes Framework zur Bewertung des Katastrophenschutzes",
    SECTION1_TITLE: "Funktionen",
    SECTION1:
      "Diese Anwendung unterstützt die Bewertung von Fähigkeiten im Katastrophenmanagement.",
    SECTION2_TITLE: "Technologie",
    SECTION2: "Erstellt mit TypeScript und modernen Web-Technologien.",
    SECTION3_TITLE: "Verwendung",
    SECTION3: "Navigieren Sie durch die Abschnitte mit der Navigationsleiste.",
  },
  ABOUT: {
    TITLE: "Über die App",
    ROUTE: "/about",
    PAGE: "Über DASF",
    INTRO: "Mehr über das DIREKTION Assessment & Screening Framework erfahren",
    SECTION1_TITLE: "Was ist DASF",
    SECTION1:
      "Das DIREKTION Assessment & Screening Framework unterstützt Organisationen beim Katastrophenmanagement.",
    SECTION2_TITLE: "Hauptfunktionen",
    SECTION2:
      "Bewertung von Fähigkeiten, Identifizierung von Lücken, Lösungsbewertung und Roadmapping.",
    SECTION3_TITLE: "Entwicklungsziele",
    SECTION3:
      "Bereitstellung eines klaren, wartbaren Rahmens für das Katastrophenmanagement.",
  },
  SETTINGS: {
    TITLE: "Einstellungen",
    ROUTE: "/settings",
    PAGE: "Anwendungseinstellungen",
    INTRO: "Konfigurieren Sie Ihre Anwendungseinstellungen",
    SECTION1_TITLE: "Spracheinstellungen",
    SECTION1: "Wechseln Sie zwischen den verfügbaren Sprachen.",
    SECTION2_TITLE: "Darstellungseinstellungen",
    SECTION2: "Passen Sie das visuelle Erscheinungsbild der Anwendung an.",
    SECTION3_TITLE: "Präferenzen",
    SECTION3: "Verwalten Sie das Anwendungsverhalten.",
  },
  LANDING: { TITLE: "Einführung", ROUTE: "/" },
  HAZARDS: { TITLE: "Gefahren", ROUTE: "/hazards" },
  SOLUTIONS: { TITLE: "Lösungen", ROUTE: "/solutions" },
  ROADMAP: { TITLE: "Fahrplan", ROUTE: "/roadmap" },
  USER: "Benutzer",
  EDITOR: "Bearbeiter",
  ADMIN: "Administrator",
  CANCEL: "Abbrechen",
  DELETE: "Löschen",
  YES: "Ja",
  NO: "Nein",
  OK: "OK",
  NAME: "Name",
  DESCRIPTION: "Beschreibung",
  DELETE_ITEM: {
    TITLE: "{item} löschen",
    DESCRIPTION: "Möchten Sie dieses {item} wirklich unwiderruflich löschen?",
  },
  SAVE_BUTTON: {
    LABEL: "Speichern",
    TOOLTIP: "Ungespeicherte Änderungen speichern",
  },
  SEARCH: "Suchen...",
  SEARCH_TOOLTIP: "/ drücken zum Suchen",
  LANGUAGE: "Sprache",
  CLEAR: "Modell leeren",
  UPLOAD: "Modell als JSON hochladen",
  DOWNLOAD: "Modell als JSON herunterladen",
  PERMALINK: "Dauerhaften Link erstellen",
  ROLE: "Rolle",
  LINK: "Link",
  MODEL: "Modell",
  TITLE: "Titel",
  AUTHORS: "Autoren",
  TYPE: "Typ",
  HITS: {
    n: "{n} Treffer",
  },
  NO_RESULTS: "Keine Ergebnisse gefunden",
  CLEAR_SEARCH: "Suche leeren",
  PAGE_NOT_FOUND: "Seite nicht gefunden",

  about_route: "/about",
  about: "Über uns",
  acronym: "Akronym",
  add_term: "Neuen Begriff hinzufügen",
  addr_how: "Wie wird es adressiert?",
  addressed: "Adressiert",
  ass_instr: "_Bewerten Sie den Beitrag einer Fähigkeit zu Ihren Zielen._",
  ass_label: "Ursache des Problems ist bekannt",
  ass_overall: "Verbesserungsbedarf",
  ass_scale: "Skala für den Bewertungsindex",
  ass_setting: "Bewertungsmatrix",
  ass: "Bewertung",
  assess_content:
    "Bestimmen Sie für jede Fähigkeit, wie wichtig sie ist und wie Ihre aktuelle Leistung ist.",
  assess: "Bewerten",
  assessment_route: "/assessment/:id",
  assessment: "Bewertung",
  avg_perf: "Gesamtbewertung",
  cap_cat: "Fähigkeitskategorie",
  cap: "Fähigkeit",
  caps: "Fähigkeiten",
  cat: "Kategorie",
  clear_all: "Alle Filter entfernen",
  clear: "Leeren",
  color: "Farbe",
  create_cap: "Fähigkeit erstellen",
  defs: "Definitionen",
  del_model: "Möchten Sie wirklich alles löschen?",
  del_model_desc: "Sind Sie sicher, dass Sie Ihr Modell löschen möchten?",
  del_proj: "Projekt löschen",
  desc_cap_instr: "Beschreiben Sie die Fähigkeit im Detail.",
  desc: "Beschreibung",
  develop_content: "Beginnen Sie mit der Entwicklung Ihrer Fähigkeiten.",
  develop: "Entwickeln",
  development: "Entwicklung",
  development_route: "/development/:id",
  dev_cap:
    "_Schlagen Sie neue Projekte zur Entwicklung Ihrer Fähigkeit vor. Beginnen Sie mit der Auswahl einer Fähigkeit._",
  doc_id: "Dokument-ID",
  doc: "Dokumentation",
  download: "Herunterladen",
  duration: "Dauer",
  edit: "Bearbeiten",
  view: "Ansehen",
  evaluation_route: "/evaluation/:id",
  evaluation: "Auswertung",
  exp_perf: "Erwartete Leistung",
  expl: "Erklärung",
  expl2: "Leistung",
  filter_cap: "Fähigkeiten filtern",
  filter_caps: "Fähigkeiten filtern",
  filter_ph: "Titel oder Beschreibung",
  filter_text_ph: "Begriff oder Beschreibung",
  filter_text: "Filtertext",
  filters: "Filter",
  relevance: "Relevanz",
  gap_scale: "Skala für die Lücke",
  gap_settings: "##### Einstellungen für Lücken",
  gap: "Lücke",
  gaps_common: "Häufige Lücken oder Problemursachen",
  gaps: "Lücken",
  gng: "###### GO / NO GO Entscheidung<br>",
  go: "GO",
  goal_scale: "Skala für die Bewertungsthemen",
  goals_instr: "Lang- und kurzfristige Ziele festlegen",
  goal: "Ziel",
  goals: "Ziele",
  group_goals_instr:
    "1. **Legen Sie die Gruppenziele fest, die Sie erreichen möchten.**\n2. Geben Sie Ihre Stakeholder an und legen Sie deren organisatorische Ziele fest.\n3. Geben Sie Fähigkeitskategorien an, um die Fähigkeiten zu organisieren.\n4. Geben Sie die Fähigkeiten an, die Sie benötigen, um die Gruppenziele zu erreichen.",
  group_goals: "Gruppenziele festlegen",
  home_route: "/",
  home: "START",
  id: "ID",
  importance: "Wichtigkeit",
  in_months: "In Monaten",
  loc: "Raum/Standort",
  main_goals: "Ziele",
  assess_capability_importance_for_capability:
    'Bewerten Sie die Bedeutung von "{capability}" für den gewählten Geltungsbereich.',
  max_imp: "Maximaler Beitrag",
  name: "Name",
  no_go: "NO GO",
  no: "Nein",
  org_dept: "Organisation / Abteilung",
  overview_route: "/overview",
  overview: "Übersicht",
  level: "Stufe",
  perf_asp: "Leistungsaspekt",
  perf_asps: "Leistungsaspekte",
  assess_performance_aspects_for_capability:
    "Bewerten Sie die Leistungsaspekte von {capability}.",
  perf_effectiveness_tooltip: "Wie effektiv ist {capability}?",
  perf_safety_professionals_tooltip:
    "Wie hoch ist das Niveau der physischen und mentalen Sicherheit des operativen Personals, das an {capability} arbeitet?",
  perf_efficiency_tooltip: "Wie effizient ist {capability}?",
  perf_scale: "Skala für Leistungspunkte",
  perf_settings: "##### Bewertungseinstellungen",
  perf: "Leistung",
  period: "JJJJ Q1 oder JJJJ M1",
  permalink: "Permalink",
  pers_inv: "Beteiligte Personen",
  pick_more: "Eines oder mehrere auswählen",
  pick_one: "Eines auswählen",
  prep_content: "_Definieren Sie die Ziele Ihrer Organisation._",
  preparation_route: "/ziele",
  preparation: "Ziele festlegen",
  prepare_content: "Erstellen oder wählen Sie die wichtigen Fähigkeiten.",
  prepare: "Vorbereiten",
  prob_areas: "Problembereiche",
  gap_problem_categories_intro:
    "Analysieren Sie diese Fähigkeitslücke anhand der folgenden Problemkategorien.",
  gap_likert_severity: "Schweregrad",
  gap_likert_severity_start_label: "Sehr niedrig",
  gap_likert_severity_middle_label: "Mittel",
  gap_likert_severity_end_label: "Sehr hoch",
  gap_likert_probability: "Wahrscheinlichkeit",
  gap_likert_probability_start_label: "Keine Änderung",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Große Abnahme",
  gap_likert_impact: "Auswirkung",
  gap_likert_impact_start_label: "Keine Änderung",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Große Abnahme",
  gap_likert_severity_tooltip:
    "Wie bewerten Sie den Schweregrad dieser Fähigkeitslücke?",
  gap_likert_probability_tooltip:
    "Angenommen, die Lücke wird geschlossen: Was würde dies für die Eintrittswahrscheinlichkeit der Lücke bedeuten?",
  gap_likert_impact_tooltip:
    "Angenommen, die Lücke wird geschlossen. Was würde dies für die Verringerung der Auswirkungen der ursprünglichen Lücke bedeuten?",
  prob: "Problem",
  proj_app: "###### PROJEKT GENEHMIGT<br>",
  proj_name: "Projektname",
  proj_prop: "Neues Projekt oder Vorschlag",
  proj_sum: "Projektzusammenfassung",
  prop_name: "Vorschlagsname",
  prop_new: "Neuer Vorschlag",
  ref: "Referenz",
  ref_url: "Referenz-URL",
  select_cap: "Fähigkeit auswählen",
  select_cat: "Kategorie auswählen",
  select_m_ph: "Eines oder mehrere auswählen",
  select_subcat: "Unterkategorie auswählen",
  settings_route: "/settings",
  settings: "Einstellungen",
  sh_filter: "Beteiligte Organisationen filtern",
  sh_org: "Stakeholder-Organisationen",
  sh_settings: "##### Einstellungen für Stakeholder",
  sh_type: "Art des Stakeholders",
  sh_types: "Stakeholder-Typen",
  sh: "Interessengruppe",
  shs: "Interessengruppen",
  other_stakeholder: "Bitte beschreiben Sie den anderen Stakeholder",
  spec_cap_instr:
    "1. Legen Sie die Gruppenziele fest, die Sie erreichen möchten.\n2. Geben Sie Ihre Stakeholder an und legen Sie deren organisatorische Ziele fest.\n3. Geben Sie Fähigkeitskategorien an, um die Fähigkeiten zu organisieren.\n4. **Geben Sie die Fähigkeiten an, die Sie benötigen, um die Gruppenziele zu erreichen.**",
  spec_cap: "Fähigkeiten festlegen",
  spec_cat_instr:
    "1. Legen Sie die Gruppenziele fest, die Sie erreichen möchten.\n2. Geben Sie Ihre Stakeholder an und legen Sie deren organisatorische Ziele fest.\n3. **Geben Sie Fähigkeitskategorien an, um die Fähigkeiten zu organisieren.**\n4. Geben Sie die Fähigkeiten an, die Sie benötigen, um die Gruppenziele zu erreichen.",
  spec_cat: "Kategorien festlegen",
  spec_sh_instr:
    "1. Legen Sie die Gruppenziele fest, die Sie erreichen möchten.\n2. **Geben Sie Ihre Stakeholder an und legen Sie deren organisatorische Ziele fest.**\n3. Geben Sie Fähigkeitskategorien an, um die Fähigkeiten zu organisieren.\n4. Geben Sie die Fähigkeiten an, die Sie benötigen, um die Gruppenziele zu erreichen.",
  spec_sh: "Interessengruppen festlegen",
  start_time: "Startzeit",
  subcat: "Unterkategorie",
  task_settings: "##### Aufgabeneinstellungen",
  task: "Aufgabe",
  task2perf: "##### Aufgaben-zu-Leistungs-Tabelle",
  tasks: "Aufgaben",
  ass_task_scale: "Aufgabenskala",
  ass_perf_scale: "Leistung",
  taxonomy_route: "/taxonomy",
  taxonomy: "Taxonomie",
  tax_def:
    "#### Taxonomie\n\nDefinitionen und Abkürzungen häufig verwendeter Begriffe.",
  TAXONOMY: {
    HAZARD: "Gefahr",
    HAZARD_DEF:
      "Ein Prozess, Phänomen oder menschliche Aktivität, der Menschenleben, Verletzungen, Störungen oder Umweltschäden verursachen kann.",
    HAZARD_TYPE: "Gefahrentyp",
    HAZARD_TYPE_DEF:
      "Eine Klasse von Gefahren mit ähnlichem Ursprung oder ähnlichen Merkmalen, wie natürliche, technologische oder menschengemachte Gefahren.",
    DISASTER: "Katastrophe",
    DISASTER_DEF:
      "Eine schwerwiegende Störung einer Gemeinschaft oder Gesellschaft, die deren Kapazitäten mit eigenen Mitteln übersteigt.",
    EMERGENCY: "Notfall",
    EMERGENCY_DEF:
      "Eine Situation, die sofortige koordinierte Maßnahmen zum Schutz von Leben, Gesundheit, Eigentum oder Umwelt erfordert.",
    DISASTER_RISK: "Katastrophenrisiko",
    DISASTER_RISK_DEF:
      "Das Potenzial für Verluste durch Gefahrenereignisse, bestimmt durch Gefahr, Exposition, Verwundbarkeit und Kapazität.",
    EXPOSURE: "Exposition",
    EXPOSURE_DEF:
      "Die Präsenz von Menschen, Gütern, Infrastruktur und Dienstleistungen an Orten, wo Gefahren auftreten können.",
    VULNERABILITY: "Verwundbarkeit",
    VULNERABILITY_DEF:
      "Bedingungen, die die Anfälligkeit von Menschen, Gütern oder Systemen gegenüber Gefahrenauswirkungen erhöhen.",
    CAPACITY: "Kapazität",
    CAPACITY_DEF:
      "Die Stärken und Ressourcen, die verfügbar sind, um Gefahrenauswirkungen vorherzusehen, zu bewältigen, zu widerstehen und sich davon zu erholen.",
    CAPABILITY: "Fähigkeit",
    CAPABILITY_DEF:
      "Eine spezifische, nachweisbare Fähigkeit einer Organisation, Aufgaben unter definierten Bedingungen auszuführen und Ergebnisse zu erzielen.",
    RESILIENCE: "Resilienz",
    RESILIENCE_DEF:
      "Die Fähigkeit von Systemen und Gemeinschaften, zu widerstehen, aufzunehmen, sich anzupassen und sich zu erholen, während wesentliche Funktionen erhalten bleiben.",
    PREVENTION: "Prävention",
    PREVENTION_DEF:
      "Maßnahmen zur Vermeidung der Entstehung neuer Risiken und zur Verhinderung schädlicher Auswirkungen von Gefahren.",
    MITIGATION: "Minderung",
    MITIGATION_DEF:
      "Maßnahmen, die den Schweregrad oder die Wahrscheinlichkeit nachteiliger Auswirkungen von Gefahrenereignissen reduzieren.",
    PREPAREDNESS: "Vorbereitung",
    PREPAREDNESS_DEF:
      "Wissen, Pläne und Kapazitäten, die im Voraus entwickelt werden, um eine wirksame Antizipation, Reaktion und Erholung zu ermöglichen.",
    EARLY_WARNING_SYSTEM: "Frühwarnsystem",
    EARLY_WARNING_SYSTEM_DEF:
      "Ein integriertes System zur Überwachung von Gefahren, Risikobewertung, Kommunikation von Warnungen und Ermöglichung rechtzeitiger Maßnahmen.",
    RESPONSE: "Reaktion",
    RESPONSE_DEF:
      "Maßnahmen, die unmittelbar vor, während oder nach einem Ereignis ergriffen werden, um Leben zu retten und dringende Bedürfnisse zu erfüllen.",
    RECOVERY: "Erholung",
    RECOVERY_DEF:
      "Der Prozess der Wiederherstellung und Verbesserung von Lebensgrundlagen, Dienstleistungen, Infrastruktur und Systemen nach einer Katastrophe.",
    BUILD_BACK_BETTER: "Besser wiederaufbauen",
    BUILD_BACK_BETTER_DEF:
      "Nutzung von Erholung und Wiederaufbau, um künftige Risiken zu verringern und die Resilienz über den Zustand vor der Katastrophe hinaus zu verbessern.",
    CONTINGENCY_PLANNING: "Notfallplanung",
    CONTINGENCY_PLANNING_DEF:
      "Vorbereitung spezifischer operativer Pläne und Koordinationsvereinbarungen für plausible Notfallszenarien.",
    RISK_ASSESSMENT: "Risikobewertung",
    RISK_ASSESSMENT_DEF:
      "Ein strukturierter Prozess zur Identifizierung von Gefahren, Analyse von Konsequenzen und Schätzung von Risiken zur Entscheidungsunterstützung.",
    RISK_COMMUNICATION: "Risikokommunikation",
    RISK_COMMUNICATION_DEF:
      "Bidirektionaler Austausch von Risikoinformationen zwischen Behörden, Einsatzkräften, Stakeholdern und der Öffentlichkeit.",
    SITUATION_AWARENESS: "Lagebewusstsein",
    SITUATION_AWARENESS_DEF:
      "Ein aktuelles und gemeinsames Verständnis der Vorfallbedingungen, Auswirkungen, Ressourcen und wahrscheinlichen Entwicklungen.",
    INCIDENT_COMMAND: "Einsatzleitung",
    INCIDENT_COMMAND_DEF:
      "Eine Führungs- und Koordinationsstruktur zur Verwaltung von Rollen, Entscheidungen und Ressourcen während Vorfällen.",
    STAKEHOLDER: "Stakeholder",
    STAKEHOLDER_DEF:
      "Jede Organisation, Gruppe oder Einzelperson mit einer Rolle, Verantwortung oder Interesse an Vorbereitung, Reaktion oder Erholung.",
    INTEROPERABILITY: "Interoperabilität",
    INTEROPERABILITY_DEF:
      "Die Fähigkeit von Organisationen, Teams und Systemen, über Verfahren, Daten und Technologie hinweg effektiv zusammenzuarbeiten.",
    CAPABILITY_GAP: "Fähigkeitslücke",
    CAPABILITY_GAP_DEF:
      "Der Unterschied zwischen erforderlichen und aktuellen Fähigkeitsniveaus, die zur Erreichung der Ziele benötigt werden.",
    CAPABILITY_ASSESSMENT: "Fähigkeitsbewertung",
    CAPABILITY_ASSESSMENT_DEF:
      "Eine strukturierte Bewertung der Bedeutung und Leistung von Fähigkeiten zur Identifizierung von Verbesserungsprioritäten.",
    SOLUTION: "Lösung",
    SOLUTION_DEF:
      "Eine Maßnahme, Praxis, Technologie oder Intervention zur Behebung einer oder mehrerer Fähigkeitslücken.",
    SOLUTION_ASSESSMENT: "Lösungsbewertung",
    SOLUTION_ASSESSMENT_DEF:
      "Eine systematische Beurteilung von Kandidatenlösungen hinsichtlich Nutzerbedürfnissen, operativer Eignung, Auswirkungen und Compliance.",
    ROADMAP: "Fahrplan",
    ROADMAP_DEF:
      "Ein phasenweiser Umsetzungsplan, der zeigt, was von wem und wann geliefert wird.",
    IMPLEMENTATION_TIMELINE: "Umsetzungszeitplan",
    IMPLEMENTATION_TIMELINE_DEF:
      "Die geplante Abfolge und Zeitplanung von Aktivitäten, Meilensteinen und Ergebnissen für die Umsetzung.",
    PRIORITIZATION: "Priorisierung",
    PRIORITIZATION_DEF:
      "Rangfolge von Maßnahmen oder Investitionen nach Dringlichkeit, erwarteter Wirkung, Machbarkeit und verfügbaren Ressourcen.",
    MONITORING_EVALUATION: "Monitoring und Evaluierung",
    MONITORING_EVALUATION_DEF:
      "Fortlaufende Verfolgung und regelmäßige Überprüfung von Fortschritt, Ergebnissen und Effektivität zur Unterstützung von Lernen und Anpassung.",
    LESSONS_LEARNED: "Gewonnene Erkenntnisse",
    LESSONS_LEARNED_DEF:
      "Dokumentierte Erkenntnisse aus Operationen und Übungen, die zur Verbesserung zukünftiger Planung und Leistung genutzt werden.",
    SESSION: "Bewertungssitzung",
    SESSION_DEF:
      "Ein gespeicherter Arbeitskontext mit ausgewählten Gefahren, Bewertungen, Lösungen und Fahrplandaten.",
    COMPLIANCE_CHECK: "Compliance-Prüfung",
    COMPLIANCE_CHECK_DEF:
      "Eine Überprüfung, dass vorgeschlagene Lösungen und Maßnahmen rechtliche, politische, ethische und branchenspezifische Anforderungen erfüllen.",
    TECHNOLOGY_READINESS_LEVEL: "Technologiereifegradstufe",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "Eine Skala von 1 bis 9, die die Reife einer Technologie vom Konzept bis zur operativen Bereitstellung angibt.",
  },
  term: "Begriff",
  title: "Titel",
  upload: "Hochladen",
  url: "URL",
  value: "Wert",
  yes: "Ja",
  TBD: "Unbekannt",
  general_settings: "Allgemein",
  enable_sol_ass_support: "Lösungsbewertung aktiviert",
  logo: "Benutzerlogo",
  attribution_logo: "Attributions-Logo",
  attribution_text: "Attributionstext",
  order: "Reihenfolge",
  hide: "In Übersicht ausblenden",
  select_user: "Benutzer auswählen",
  user: "Normaler Benutzer",
  moderator: "Moderator",
  admin: "Administrator",
  doc_title: "Fähigkeitsbewertungsbericht",
  export_to_word: "Als Word exportieren",
  export_all_to_word: "Vollständigen Bericht als Word exportieren",
  add_gap: "Fähigkeitslücke hinzufügen",
  ignore: "Nicht anwendbar",
  continue: "Weiter",
  hazards: "Gefahren",
  hazards_route: "/hazards",
  hazard_step_title: "Schritt 0: Initiierung & Vorbereitung",
  hazard_step_desc:
    "Wählen Sie die Gefahrenarten aus, die für den in diesem Assessment-Workshop zu behandelnden Umfang relevant sind.",
  workshop_scope: "Workshop-Umfang",
  hazard_category_all: "Alle",
  hazard_category_natural: "Natürlich",
  hazard_category_technical: "Technisch",
  hazard_category_attack: "Angriff",
  hazard_edit: "Gefahrenarten bearbeiten",
  hazard_done: "Bearbeitung abschließen",
  hazard_add: "Neue Gefahrenart hinzufügen",
  hazard_name: "Gefahrenname",
  hazard_description: "Beschreibung / Kontext",
  hazard_selected_count: "{n} Gefahrenart(en) ausgewählt.",
  solutions: "Lösungen",
  solution_count: {
    1: "1 Lösung",
    n: "{n} Lösungen",
  },
  solutions_route: "/solutions",
  solutions_step_title: "Schritt 2: Lösungsbewertung",
  solutions_step_desc:
    "Lösungen für identifizierte Fähigkeitslücken hinzufügen und bewerten.",
  solution_add: "Lösung hinzufügen",
  solution_new: "Neue Lösung",
  solution_gaps_found: {
    1: "1 Fähigkeitslücke identifiziert",
    n: "{n} Fähigkeitslücken identifiziert",
  },
  solution_empty:
    "Noch keine Lösungen hinzugefügt. Klicken Sie auf 'Lösung hinzufügen', um zu beginnen.",
  roadmap: "Fahrplan",
  roadmap_count: {
    1: "1 Fahrplanelement",
    n: "{n} Fahrplanelemente",
  },
  roadmap_route: "/roadmap",
  roadmap_step_title: "Schritt 3: Fahrplanung",
  roadmap_step_desc: "Implementierungszeitpläne und Verpflichtungen planen.",
  roadmap_add_solutions: "{n} Lösung(en) zum Fahrplan hinzufügen",
  roadmap_empty_solutions:
    "Schließen Sie zuerst Schritt 2 (Lösungsbewertung) ab, um Lösungen zum Fahrplan hinzuzufügen.",
  roadmap_empty: "Noch keine Fahrplanelemente.",
  roadmap_timeline: "Zeitplan",
  session_create: "Erstellen",
  session_new_name: "Name der neuen Sitzung",
  session_sessions: "Bewertungssitzungen",
  session_name: "Name",
  session_updated: "Zuletzt aktualisiert",
  session_actions: "Aktionen",
  session_clone: "Sitzung klonen",
  session_download: "Als JSON herunterladen",
  session_delete: "Sitzung löschen",
  session_import: "JSON importieren",
  session_delete_confirm: "Sitzung löschen: {name}?",
  session_delete_warning:
    "Dies kann nicht rückgängig gemacht werden. Sind Sie sicher?",
  dashboard_subtitle:
    "Folgen Sie den untenstehenden Schritten für Ihre Katastrophenmanagement-Bewertung.",
  back_to_sessions: "Zurück zu den Sitzungen",
  step0_title: "Initiierung & Vorbereitung",
  step1_title: "Bedarfs- & Lückenbewertung",
  step2_title: "Lösungsbewertung",
  step3_title: "Fahrplanung",
  summary: "Zusammenfassung",
  selected_hazards: "Ausgewählte Gefahren",
  capability_gaps: "Fähigkeitslücken",
  more: "mehr",
  partially: "Teilweise",
  not_assessed: "Nicht bewertet",
  enabled_steps: "Aktivierte Schritte",
  priority_low: "Niedrig",
  priority_medium: "Mittel",
  priority_high: "Hoch",
  sol_trl: "Technologiereifegradstufe",
  trl1: "Grundprinzipien beobachtet",
  trl2: "Technologiekonzept formuliert",
  trl3: "Experimenteller Konzeptnachweis",
  trl4: "Technologie im Labor validiert",
  trl5: "Technologie in relevantem Umfeld validiert",
  trl6: "Technologie in relevantem Umfeld demonstriert",
  trl7: "Systemprototyp in operativem Umfeld demonstriert",
  trl8: "System vollständig und qualifiziert",
  trl9: "Tatsächliches System in operativem Umfeld nachgewiesen",
  sol_integration_rl: "Integrationsreifegrad",
  sol_societal_rl: "Gesellschaftlicher Reifegrad",
  sol_manufacturing_rl: "Fertigungsreifegrad",
  sol_commercialisation_rl: "Kommerzialisierungsreifegrad",
  sol_security_rl: "Sicherheitsreifegrad",
  sol_legal_privacy_ethical_rl:
    "Rechtlicher, Datenschutz- und ethischer Reifegrad",
  integration_rl1: "Ein übergeordnetes Integrationskonzept wurde identifiziert",
  integration_rl2:
    "Ein gewisser Spezifizierungsgrad der Anforderungen an die Komponenteninteraktion liegt vor",
  integration_rl3:
    "Das detaillierte Integrationsdesign wurde definiert und umfasst alle Schnittstellendetails",
  integration_rl4:
    "Validierung der Funktionen integrierter Komponenten in einer Laborumgebung",
  integration_rl5:
    "Validierung integrierter Komponenten in einer relevanten Umgebung",
  integration_rl6:
    "Validierung integrierter Komponenten in einer relevanten End-to-End-Umgebung",
  integration_rl7:
    "Demonstration der Prototypintegration in einer hochrealistischen operativen Umgebung",
  integration_rl8: "Test und Demonstration in einer operativen Umgebung",
  integration_rl9:
    "Nachgewiesene Systemintegration durch erfolgreiche operationelle Einsatzfähigkeiten",
  societal_rl1:
    "Identifikation des allgemeinen gesellschaftlichen Bedarfs, des sozialen Nutzens und der damit verbundenen Aspekte",
  societal_rl2:
    "Formulierung des vorgeschlagenen Lösungskonzepts und der potenziellen Auswirkungen",
  societal_rl3:
    "Eine begrenzte Gruppe der Gesellschaft kennt die Lösung oder ähnliche Initiativen",
  societal_rl4:
    "Eine begrenzte Gruppe der Gesellschaft testet die Lösung oder ähnliche Initiativen",
  societal_rl5:
    "Die Gesellschaft kennt die Lösung oder ähnliche Initiativen, ist sich ihrer Vorteile jedoch nicht bewusst",
  societal_rl6:
    "Die Gesellschaft kennt die Lösung und das Bewusstsein für ihre Vorteile nimmt zu",
  societal_rl7:
    "Die Gesellschaft ist sich der Vorteile der Lösung vollständig bewusst",
  societal_rl8:
    "Die Gesellschaft ist bereit, die Lösung zu übernehmen, und hat ähnliche Lösungen am Markt genutzt",
  societal_rl9:
    "Die Gesellschaft nutzt die Lösung und sie wird von Interessengruppen und Öffentlichkeit unterstützt",
  manufacturing_rl1: "Grundlegende Fertigungsimplikationen identifiziert",
  manufacturing_rl2: "Fertigungskonzepte identifiziert",
  manufacturing_rl3: "Fertigungs-Konzeptnachweis entwickelt",
  manufacturing_rl4:
    "Fähigkeit, die Technologie in einer Laborumgebung herzustellen",
  manufacturing_rl5:
    "Fähigkeit, Prototypkomponenten in einer produktionsrelevanten Umgebung herzustellen",
  manufacturing_rl6:
    "Fähigkeit, ein Prototypsystem oder -subsystem in einer produktionsrelevanten Umgebung herzustellen",
  manufacturing_rl7:
    "Fähigkeit, Systeme, Subsysteme oder Komponenten in einer produktionsrepräsentativen Umgebung herzustellen",
  manufacturing_rl8:
    "Pilotlinienfähigkeit nachgewiesen. Bereit für den Beginn einer Kleinserienproduktion",
  manufacturing_rl9:
    "Kleinserienproduktion nachgewiesen. Voraussetzungen für den Beginn der Vollserienproduktion vorhanden",
  commercialisation_rl1: "Forschung und Grundhypothese",
  commercialisation_rl2: "Marktbewertung",
  commercialisation_rl3: "Validierung von Technologieanwendung und Markt",
  commercialisation_rl4: "Wertversprechen",
  commercialisation_rl5: "Produktentwicklung und Marktausrichtung",
  commercialisation_rl6:
    "Produkt-/Lösungsoptimierung und Schutz geistigen Eigentums",
  commercialisation_rl7: "Technische und kommerzielle Validierung",
  commercialisation_rl8: "Kommerzialisierungsstrategie und Markteinführung",
  commercialisation_rl9: "Vollständige Markteinführung und Lizenzerlöse",
  security_rl1: "Sicherheitsbetrachtung",
  security_rl2: "Entwicklung eines Sicherheitskonzepts",
  security_rl3: "Sicherheit durch Design",
  security_rl4: "Vorbereitung von Sicherheitsmaßnahmen und -funktionen",
  security_rl5: "Einfache Sicherheitsvalidierung",
  security_rl6: "Sequenzielle Sicherheitsdemonstration",
  security_rl7: "Komplexe Sicherheitsdemonstrationen",
  security_rl8:
    "Abschließende Sicherheitsvalidierung und Vorbereitung vor der Freigabe",
  security_rl9: "Initiale operative Sicherheit",
  security_rl10: "Gut etablierte/zuverlässige Sicherheit",
  legal_privacy_ethical_rl1:
    "Kontrolle über rechtliche, ethische und Datenschutzfragen: Das System hat Kontrollmechanismen für Rechenschaftspflicht implementiert und, falls zutreffend, Standard-Benchmarks bestanden und eine Zertifizierung erhalten",
  legal_privacy_ethical_rl2:
    "Ethische Spannungen durch Ethics-by-Design adressiert: Die rechtlichen, ethischen und Datenschutzaspekte des Systems wurden so gestaltet, dass sie miteinander vereinbar sind. Ethische Spannungen wurden adressiert, sodass die Verbesserung eines Aspekts keinen anderen Aspekt negativ beeinflusst",
  legal_privacy_ethical_rl3:
    "Charakterisierte rechtliche, ethische und Datenschutz-Interaktionen: Die Wechselwirkungen zwischen verschiedenen ethischen und Datenschutzaspekten wurden charakterisiert",
  legal_privacy_ethical_rl4:
    "Identifizierte rechtliche, ethische und Datenschutzfragen: Die durch das System aufgeworfenen ethischen und Datenschutzaspekte wurden identifiziert und antizipiert",
  sol_linked_caps: "Verknüpfte Fähigkeiten (mit Lücken)",
  sol_addressed_gaps: "Adressierte Fähigkeitslücken",
  sol_no_gaps:
    "Es wurden noch keine Fähigkeitslücken identifiziert. Gehen Sie zu Schritt 1, um Fähigkeiten zu bewerten.",
  sol_compliance_title: "Compliance-Prüfungen",
  sol_status: "Status",
  sol_pass: "Bestanden",
  sol_partial: "Teilweise",
  sol_fail: "Nicht bestanden",
  sol_na: "N/A",
  sol_not_applicable: "Nicht anwendbar",
  sol_user_needs_title: "Bewertung der Nutzerbedürfnisse",
  sol_operational_needs_title: "Bewertung der operativen Bedürfnisse",
  sol_organisational_needs_title: "Bewertung der organisatorischen Bedürfnisse",
  sol_expected_impact_title: "Bewertung der erwarteten Auswirkungen",
  sol_question: "Frage",
  sol_response: "Antwort",
  UN01: "Ist die Lösung einfach zu bedienen?",
  UN02: "Funktioniert die Lösung wahrscheinlich angemessen unter Druck? Einschließlich Robustheit und Zuverlässigkeit.",
  UN03: "Wird die Lösung wahrscheinlich von den Benutzern akzeptiert?",
  UN04: "Unterstützt die Lösung wahrscheinlich das Verständnis der Benutzer?",
  UN05: "Unterstützt die Lösung wahrscheinlich die Erklärbarkeit für Benutzer?",
  UN06: "Verbessert die Lösung wahrscheinlich die Effizienz der Benutzer?",
  UN07: "Verbessert die Lösung wahrscheinlich die Effektivität der Benutzer?",
  UN08: "Bietet die Lösung wahrscheinlich zusätzliches Wissen?",
  UN09: "Erzeugt die Lösung wahrscheinlich konsistent positive Interventionen und/oder Ergebnisse?",
  ON01: "Erfordert die Lösung wahrscheinlich umfangreiche (Wieder-)Schulungen?",
  ON02: "Erfordert die Lösung wahrscheinlich übermäßige Wartung und Unterstützung?",
  ON03: "Ist die Lösung wahrscheinlich kompatibel mit Ihren Betriebsmethoden/SOPs?",
  ON04: "Ist die Lösung interoperabel?",
  ON05: "Ist die Lösung wahrscheinlich anpassungsfähig und übertragbar auf Ihre Betriebsszenarien?",
  ON06: "Unterstützt die Lösung wahrscheinlich Gesundheit und Sicherheit der Einsatzkräfte?",
  ON07: "Erreicht die Lösung wahrscheinlich die beabsichtigte Zielgruppe?",
  ON08: "Bietet die Lösung wahrscheinlich verbesserte operative Effizienz?",
  ON09: "Bietet die Lösung wahrscheinlich verbesserte operative Effektivität?",
  OG01: "Hat die Lösung wahrscheinlich eine positive Kosten-Nutzen-Bilanz?",
  OG02: "Erscheint die Lösung machbar? Einschließlich technologisch, wirtschaftlich, rechtlich, operativ und zeitlich.",
  OG03: "Ist die Lösung wahrscheinlich kompatibel mit Ihrer Organisationskultur?",
  OG04: "Ist die Lösung wahrscheinlich kompatibel mit Ihrem organisatorischen Auftrag?",
  OG05: "Ist die Lösung wahrscheinlich kompatibel mit den Prioritäten des Krisenmanagements?",
  OG06: "Würde die Nutzung der Lösung Ihren Ruf in der Öffentlichkeit unterstützen?",
  OG07: "Würde die Nutzung der Lösung dazu beitragen, die Gemeinschaftsbeziehungen zu verbessern?",
  EI01: "Wird die Lösung im Bereich der menschlichen Gesundheitsversorgung eingesetzt?",
  EI02: "Umfasst die Lösung die Verarbeitung personenbezogener Daten?",
  EI03: "Hat die Lösung wahrscheinlich negative Auswirkungen auf die Rechte und Freiheiten von Einzelpersonen und Gruppen? Z.B. Privatsphäre, Würde, Autonomie, Solidarität.",
  EI04: "Hat die Lösung wahrscheinlich negative Auswirkungen in Bezug auf soziale Gerechtigkeit und Gleichheit?",
  EI05: "Hat die Lösung wahrscheinlich negative Auswirkungen auf das Wohlbefinden von Einzelpersonen oder Gruppen?",
  EI06: "Erhöht die Lösung wahrscheinlich die Verwundbarkeit von Einzelpersonen oder Gruppen?",
  EI07: "Birgt die Lösung wahrscheinlich potenzielle Sicherheitsrisiken?",
  EI08: "Hat die Lösung wahrscheinlich negative Auswirkungen auf die Umwelt?",
  EI09: "Besteht eine ERHEBLICHE Unsicherheit hinsichtlich der rechtlichen, ethischen und gesellschaftlichen Auswirkungen der Nutzung der Lösung?",
  CC01: "(Cyber-)Sicherheit",
  CC02: "Interoperabilität",
  CC03: "KI-Verordnung",
  CC04: "Gemeinschaftseinbindung",
  CC05: "DSGVO",
  CC06: "Grundrechte",
  CC07: "Nachhaltigkeitsziele",
  CC08: "Krisenmanagementprioritäten auf nationaler Ebene",
  CC09: "Branchenspezifische Standards",
  CC10: "Branchenspezifische Gesetze und Vorschriften",
  cap_add_from_ref: "Fähigkeiten aus Referenz hinzufügen",
  cap_all_selected:
    "Alle Referenzfähigkeiten wurden Ihrer Sitzung hinzugefügt.",
  cap_add_selected: "Ausgewählte Fähigkeiten hinzufügen",
  cap_ref_panel_title: "Verfügbare Fähigkeiten (DASF-Referenzmodell)",
  collapse: "Einklappen",
  step0_abbr: "Schritt 0: I&V",
  step0_desc:
    "Relevante Gefahrenarten für Ihren Bewertungskontext identifizieren.",
  step1_abbr: "Schritt 1: BLB",
  step1_desc:
    "Fähigkeiten bewerten, Lücken und Verbesserungsbedarf identifizieren.",
  step2_abbr: "Schritt 2: LB",
  step2_desc: "Lösungen für identifizierte Fähigkeitslücken auswerten.",
  step3_abbr: "Schritt 3: FP",
  step3_desc: "Implementierungsfahrplan und Verpflichtungen planen.",
  landing_attribution:
    "DIREKTION hat Fördermittel aus dem Forschungs- und Innovationsprogramm Horizon Europe der Europäischen Union gemäß Fördervereinbarung Nr. 101121249 erhalten.",
  landing_developed_by: "Entwickelt von",
  landing_as_part_of: "als Teil des",
  landing_project: "Projekts.",
  dasf_purpose_title: "Zweck des DASF",
  dasf_purpose_p1:
    "Das DIREKTION Assessment and Screening Framework (DASF) ist eine Kernmethode, die im Rahmen des DIREKTION-Projekts entwickelt wurde, um einen transparenten und unparteiischen Screening- und Bewertungsprozess zu unterstützen.",
  dasf_purpose_offers:
    "Das DASF-Framework bietet eine schrittweise Methode, um:",
  dasf_purpose_item1: "Fähigkeitslücken zu identifizieren und zu beheben",
  dasf_purpose_item2:
    "Systematisches Screening von Technologien und Lösungen umzusetzen",
  dasf_purpose_item3: "Eine Roadmap zu erstellen",
  dasf_purpose_p2:
    "Das DASF bildet die Grundlage für einen nachhaltigen Prozess der Forschungsprogrammierung und stellt sicher, dass Einsatzkräfte und Interessengruppen Zugang zu den effektivsten und aktuellsten Werkzeugen für die Katastrophenvorsorge und -reaktion haben. Das vollständige Set soll regelmäßig durchgeführt werden — zum Beispiel einmal im Jahr oder einmal alle vier Jahre — um einen aktualisierten Einblick in die aktuellen Fähigkeitsbedürfnisse, Fähigkeitslücken, potenzielle Lösungen zu erhalten und die Roadmap für EU- oder nationale Forschungsmöglichkeiten regelmäßig zu aktualisieren.",
  landing_assessment_process: "Bewertungsprozess",
  landing_video_tutorial: "Videoanleitung auf YouTube ansehen",
  landing_funded_by: "Finanziert von der Europäischen Union",
  landing_trilateral_attribution:
    "Für die Erstellung dieses Tools wurden wesentliche Beiträge von Trilateral Research verwendet, die im Rahmen von DIREKTION D1.2 entwickelt wurden.",
  delete_session_confirm: "Sitzung löschen: {name}?",
  delete_session_warning:
    "Dies kann nicht rückgängig gemacht werden. Sind Sie sicher?",
  N01: "Erdbeben",
  N02: "Tsunami",
  N03: "Vulkanausbruch",
  N04: "Erdrutsch / Lawine",
  N05: "Hochwasser",
  N06: "Sturzflut",
  N07: "Sturm / Hurrikan / Tornado",
  N08: "Waldbrand / Flächenbrand",
  N09: "Extreme Temperatur (Hitze/Kälte)",
  N10: "Dürre",
  N11: "Epidemie / Pandemie",
  N12: "Tierseuchenausbruch",
  N13: "Insektenbefall",
  T01: "Industrieunfall (CBRN)",
  T02: "Nuklearer / Radiologischer Vorfall",
  T03: "Transportunfall (Luft)",
  T04: "Transportunfall (Schiene)",
  T05: "Transportunfall (Straße)",
  T06: "Transportunfall (See)",
  T07: "Pipeline / Gasexplosion",
  T08: "Gebäude- / Bauwerkeinsturz",
  T09: "Dammbruch / Deichbruch",
  T10: "Stromausfall / Netzausfall",
  T11: "Telekommunikationsausfall",
  T12: "Trinkwasserverunreinigung",
  T13: "Gefahrgutaustritt",
  A01: "Terroranschlag (Sprengstoff)",
  A02: "Terroranschlag (CBRN)",
  A03: "Cyberangriff",
  A04: "Amoklauf / Bewaffneter Angriff",
  A05: "Sabotage kritischer Infrastruktur",
  A06: "Geiselnahme / Entführung",
  A07: "Bürgerliche Unruhen / Aufstände",
  A08: "Seepiraterie / Hijacking",
  A09: "Drohnenangriff",
  A10: "Hybride Bedrohung",
  A11: "Desinformationskampagne",
  A12: "Lieferkettenunterbrechung (absichtlich)",
  A13: "Brandstiftung",
  "Cat-01": "Minderung / Prävention",
  "Cat-02": "Vorbereitung",
  "Cat-03": "Reaktion",
  "Cat-04": "Erholung",
  "Mit-01": "Risikobewertung",
  "Mit-02": "Expositionsreduzierung",
  "Mit-03": "Minderungsunterstützung",
  "Prep-01": "Kapazitätsentwicklung",
  "Prep-02": "Überwachung",
  "Prep-03": "Vorbereitungsunterstützung",
  "Rsp-01": "Vorfall unterdrücken",
  "Rsp-02": "Rettungsoperationen",
  "Rsp-03": "Sicherheit / Strafverfolgung",
  "Rsp-04": "Notfallgesundheitsversorgung",
  "Rsp-05": "Gesellschaftskommunikation",
  "Rsp-06": "Bevölkerung / Tiere schützen",
  "Rsp-07": "Katastrophengebiet räumen",
  "Rsp-08": "Grundbedarfsversorgung",
  "Rsp-09": "Reaktionsunterstützung",
  "Rec-01": "Humanitäre Erholung",
  "Rec-02": "Umwelterholung",
  "Rec-03": "Wirtschaftliche Erholung",
  "Rec-04": "Wiederherstellung der Infrastruktur",
  "Rec-05": "Erholungsunterstützung",
  "Mit-RA-01": "Risikoidentifikation",
  "Mit-RA-02": "Risikoanalyse",
  "Mit-RA-03": "Risikobewertung",
  "Mit-ER-01": "Eigentumsschutz",
  "Mit-ER-02": "Schutz natürlicher Ressourcen",
  "Mit-ER-03": "Sensibilisierung",
  "Mit-MS-01": "Trendanalyse",
  "Mit-MS-02": "Überwachung und Überprüfung",
  "Prep-CD-01": "Reaktions- und Erholungsplanung",
  "Prep-CD-02": "Ausbildung",
  "Prep-CD-03": "Risikokommunikation",
  "Prep-MO-01": "Erkennung",
  "Prep-MO-02": "Alarmierung",
  "Prep-PS-01": "Personalmanagement",
  "Prep-PS-02": "Ressourcenmanagement",
  "Prep-PS-03": "Kooperationsaufbau",
  "Prep-EH-04": "Psychologische Betreuung",
  "Resp-SI-01": "Brandbekämpfung - Infrastrukturen",
  "Resp-SI-02": "Brandbekämpfung - Natur",
  "Resp-SI-03": "Hochwasserschutz",
  "Resp-SI04": "Gefahrgutbekämpfung (CBRN-E)",
  "Resp-RO-01": "Suche und Rettung (SAR)",
  "Resp-RO-02": "Erstversorgung am Unfallort",
  "Resp-RO-03": "Transport von Opfern",
  "Resp-SL-01": "Sicherung von Orten / Personen",
  "Resp-SL-02": "Personenidentifikation",
  "Resp-SL-03": "Forensik",
  "Resp-SL-04": "Aufrechterhaltung der öffentlichen Ordnung",
  "Resp-SL-05": "Verkehrsmanagement",
  "Resp-EH-01": "Notfallversorgung - Krankenhäuser",
  "Resp-EH-02": "Quarantäne",
  "Resp-EH-03": "Massengesundheitsversorgung",
  "Resp-CS-01": "Warnung",
  "Resp-CS-02": "Krisenkommunikation",
  "Resp-SF-01": "Evakuierung",
  "Resp-SF-02": "Unterkunft",
  "Resp-SF-03": "Familienzusammenführung",
  "Resp-DA-01": "Trümmerbeseitigung",
  "Resp-DA-02": "Dekontamination von Objekten",
  "Resp-DA-03": "Entwässerung",
  "Resp-DA-04": "Tiervernichtung",
  "Resp-BN-01": "Trinkwasserversorgung",
  "Resp-BN-02": "Nahrungsversorgung",
  "Resp-BN-03": "Energieversorgung",
  "Resp-BN-04": "Bereitstellung von IKT / Telekommunikation",
  "Resp-BN-05": "Sanitärversorgung",
  "Resp-RS-01": "Führung, Kontrolle und Koordinierung",
  "Resp-RS-02": "Lagebewertung",
  "Resp-RS-03": "Informationsmanagement",
  "Resp-RS-04": "Überwachung / Datenerhebung",
  "Resp-RS-05": "Vor-Ort-Einsatzunterstützung",
  "Resp-RS-06": "Logistik",
  "Rec-HR-01": "Öffentliche Gesundheit und Sicherheit",
  "Rec-HR-02": "Nahrung und Unterkunft",
  "Rec-ER-01": "Abfallmanagement",
  "Rec-ER-02": "Wiederherstellung von Lebensräumen",
  "Rec-EC-01": "Wirtschaftliche Erholung",
  "Rec-EC-02": "Finanzielle Erholung",
  "Rec-RI-01": "Wiederherstellung des Transports",
  "Rec-RI-02": "Wiederherstellung der Versorgung",
  "Rec-RS-01": "Erholungsorganisation aufbauen",
  "Rec-RS-02": "Erholungsprogrammierung",
  "Goal-01": "Vorfälle verhindern",
  "Goal-01_desc": "Katastrophen / Krisensituationen verhindern.",
  "Goal-02": "Verluste durch Gefahren minimieren",
  "Goal-02_desc": "Verluste durch Gefahren reduzieren / vermeiden.",
  "Goal-03": "Opfern helfen",
  "Goal-03_desc": "Schnelle und wirksame Hilfe für Opfer sicherstellen.",
  "Goal-04": "Angemessene Erholung",
  "Goal-04_desc": "Schnelle und effektive Erholung erreichen.",
  "TO-01": "Feuerwehr / Zivilschutz",
  "TO-02": "Polizei",
  "TO-03": "Notfallgesundheitsversorgung",
  "TO-04": "Verteidigung",
  "TO-05": "Lagezentrum",
  "TO-06": "Behörden",
  "TO-07": "Kritische Infrastruktur",
  "TO-08": "NGO",
  "TO-09": "Sonstige",
  "SH-01": "Feuerwehr/Zivilschutz",
  "SH-02": "Polizei",
  "SH-03": "Notfallgesundheitsversorgung",
  "SH-04": "SAR",
  "SH-05": "Lagezentrum oder Leitstelle (112)",
  "SH-06": "Behörden (Ministerien, Kommunen)",
  "SH-07": "Verteidigung",
  "SH-08": "Öffentliche Dienste",
  "SH-09": "Küstenwache oder Grenzsicherung",
  "SH-10": "Betreiber kritischer Infrastruktur",
  "SH-11": "NGO",
  "SH-12": "Sonstige (zu beschreiben)",
  "Imp-1": "Keine/Sehr gering",
  "Imp-2": "Gering",
  "Imp-3": "Mittel",
  "Imp-4": "Ziemlich hoch",
  "Imp-5": "Sehr hoch",
  "PA-1": "Effektivität",
  "PA-1_desc": "Qualität der Ergebnisse, Rechtzeitigkeit, Ausdauer.",
  "PA-2": "Sicherheit/Schutz von Fachleuten",
  "PA-2_desc": "Physische und mentale Sicherheit des beteiligten Personals.",
  "PA-3": "Effizienz",
  "PA-3_desc": "Verhältnis zwischen Kosten und Ergebnissen.",
  "PSc-1": "Schlecht",
  "PSc-2": "Unbefriedigend",
  "PSc-3": "Mäßig",
  "PSc-4": "Zufriedenstellend",
  "PSc-5": "Gut",
  "Nat-01": "Technologisch",
  "Nat-01_desc":
    "Z.B. Sensortechnologien, Führung und Kontrolle, Kommunikation und Koordinierung, IKT.",
  "Nat-02": "Menschlich",
  "Nat-02_desc":
    "Z.B. Personalstärke, Kompetenz des Personals, Ausbildung und Fortbildung.",
  "Nat-03": "Organisatorisch",
  "Nat-03_desc":
    "Z.B. Verfahren, Organisationsstruktur, Finanzaspekte, Vereinbarungen.",
  "Nat-04": "Regulatorisch",
  "Nat-04_desc": "Z.B. rechtliche Aspekte, formale Standardisierungsaspekte.",
  "Kn-01": "Unbekannt",
  "Kn-02": "Nein",
  "Kn-03": "Ja",
  "ASc-01": "Sehr gering",
  "ASc-02": "Gering",
  "ASc-03": "Mäßig",
  "ASc-04": "Hoch",
  "ASc-05": "Sehr hoch",
  "Cat-01_desc":
    "Ziel: Maßnahmen ergreifen, um die Wahrscheinlichkeit zu begrenzen und die Auswirkungen eines Vorfalls, einer Katastrophe oder Krise zu reduzieren.",
  "Cat-02_desc":
    "Ziel: Die Organisationsstruktur und Fähigkeiten zur Durchführung von Reaktions- und Erholungsaktivitäten entwickeln und pflegen.",
  "Cat-03_desc": "Ziel: Leben retten und negative Auswirkungen begrenzen.",
  "Cat-04_desc":
    "Ziel: Das normale Leben auf effiziente Weise wiederaufbauen und wiederherstellen.",
  "Mit-01_desc": "Identifikation, Analyse und Bewertung von Risiken.",
  "Mit-02_desc":
    "Schutz von Eigentum, natürlichen Ressourcen und der Gesellschaft im Allgemeinen vor Gefahren.",
  "Mit-03_desc": "Fähigkeiten zur Unterstützung der Minderung / Prävention.",
  "Prep-01_desc":
    "Prozess der Entwicklung und Aufrechterhaltung erforderlicher Krisenmanagementkapazitäten.",
  "Prep-02_desc":
    "Ermittlung des Status einer Umgebung oder Situation zur Ermöglichung der Erkennung von Vorfällen.",
  "Prep-03_desc": "Fähigkeiten zur Unterstützung der Kapazitätsentwicklung.",
  "Rsp-01_desc":
    "Vor-Ort-Aktivitäten, um die Ursache der Katastrophe zu stoppen oder einzudämmen.",
  "Rsp-02_desc": "Vor-Ort-Aktivitäten zur Lebensrettung.",
  "Rsp-03_desc":
    "Sicherung von Bereichen/Personen, Identifikation von Personen, Forensik.",
  "Rsp-04_desc": "Externe Aktivitäten zur Lebensrettung.",
  "Rsp-05_desc": "Warnung und Krisenkommunikation.",
  "Rsp-06_desc": "Kontrollierte Evakuierung von Personen und/oder Tieren.",
  "Rsp-07_desc":
    "Zugänglichkeit und Sicherheit im betroffenen Gebiet herstellen.",
  "Rsp-08_desc":
    "Lieferung und/oder Wiederherstellung von Grundprodukten und lebenswichtigen Dienstleistungen.",
  "Rsp-09_desc":
    "Fähigkeiten zur Ermöglichung einer oder mehrerer anderer Reaktionsfähigkeiten.",
  "Rec-01_desc":
    "Bereitstellung von öffentlichen Gesundheits- und Sicherheitsdiensten sowie Unterkunft.",
  "Rec-02_desc": "Beseitigung von Verschmutzung und Dekontamination.",
  "Rec-03_desc": "Wirtschaftliche und geschäftliche Erholung.",
  "Rec-04_desc":
    "Wiederherstellung von Transportwegen und wesentlichen Diensten.",
  "Rec-05_desc":
    "Fähigkeiten, die für eine gut koordinierte Erholung erforderlich sind.",
  "Mit-RA-01_desc":
    "Prozess der Suche, Erkennung und Beschreibung von Risiken.",
  "Mit-RA-02_desc":
    "Prozess zum Verständnis der Art des Risikos und zur Bestimmung des Risikoniveaus.",
  "Mit-RA-03_desc":
    "Prozess des Vergleichs von Risikoanalyseergebnissen mit Risikokriterien, um zu bestimmen, ob das Risiko akzeptabel oder tolerierbar ist.",
  "Mit-ER-01_desc": "Eigentumsschutz (einschl. kritischer Infrastrukturen).",
  "Mit-ER-02_desc":
    "Maßnahmen zur Minimierung von Gefahrenverlusten und zur Erhaltung oder Wiederherstellung natürlicher Systemfunktionen.",
  "Mit-ER-03_desc":
    "Öffentliche Aufklärung und Sensibilisierung über Gefahren und potenzielle Minderungsmaßnahmen.",
  "Mit-MS-01_desc": "Untersuchung der Entwicklung von Risiken.",
  "Mit-MS-02_desc":
    "Sicherstellen, dass Kontrollen effektiv und effizient sind, weitere Informationen zur Verbesserung der Risikobewertung gewinnen.",
  "Prep-CD-01_desc":
    "Verfahren und Informationen für den Einsatz bei einem Vorfall entwickeln, zusammenstellen und pflegen.",
  "Prep-CD-02_desc":
    "Aktivitäten zur Förderung des Lernens und der Entwicklung von Kenntnissen, Fähigkeiten und Fertigkeiten für die Katastrophenreaktion.",
  "Prep-CD-03_desc":
    "Kommunikation und Anweisung der Öffentlichkeit über Krisenvorsorge und Verhalten bei Eintreten einer Krise.",
  "Prep-MO-01_desc": "Erkennung von Umständen, die von der Norm abweichen.",
  "Prep-MO-02_desc":
    "Personal über das Vorhandensein eines Vorfalls informieren und Kontrollmaßnahmen einleiten.",
  "Prep-PS-01_desc":
    "Aktivitäten zur Bereitstellung von ausreichend qualifiziertem Personal für Reaktions- und Erholungsaufgaben.",
  "Prep-PS-02_desc":
    "Aktivitäten zur Bereitstellung von Ausrüstung, Werkzeugen, IKT und anderen Mitteln für Reaktion und Erholung.",
  "Prep-PS-03_desc":
    "Aufbau internationaler Kooperation zwischen Notfalldiensten und Dritten.",
  "Prep-EH-04_desc":
    "Psychologische Gesundheitsversorgung für Opfer, Angehörige und andere betroffene Personen.",
  "Resp-SI-01_desc":
    "Brandbekämpfung in Gebäuden, bebauten Gebieten oder Infrastrukturen.",
  "Resp-SI-02_desc": "Brandbekämpfung in natürlichen Umgebungen.",
  "Resp-SI-03_desc":
    "Wassermanagement bei Hochwasser durch Deichbruch oder Starkregen.",
  "Resp-SI04_desc":
    "Eindämmung von Gefahrgutaustritten, einschließlich Containment (CBRN-E-Vorfälle).",
  "Resp-RO-01_desc": "Such- und Rettungsoperationen.",
  "Resp-RO-02_desc": "Triage, Dekontamination und Stabilisierung von Opfern.",
  "Resp-RO-03_desc":
    "Krankentransport zu sicheren Bereichen oder Krankenhäusern.",
  "Resp-SL-01_desc":
    "Gebiete, Infrastrukturen und Personen vor unbeteiligten Parteien schützen.",
  "Resp-SL-02_desc": "Identifikation von Opfern.",
  "Resp-SL-03_desc":
    "Forensische Aktivitäten zur Untersuchung der Ursache des Vorfalls und Sicherung von Beweisen.",
  "Resp-SL-04_desc": "Aufstandsbekämpfung usw.",
  "Resp-SL-05_desc": "Verkehrssteuerung in und aus dem betroffenen Gebiet.",
  "Resp-EH-01_desc":
    "Gesundheitsdienst in regulären und/oder Feldkrankenhäusern.",
  "Resp-EH-02_desc": "Isolierung von potenziell infektiösen Personen/Opfern.",
  "Resp-EH-03_desc":
    "Massenimpfung oder -prophylaxe bei nuklearem Vorfall oder Pandemie.",
  "Resp-CS-01_desc":
    "Gesellschaft in der bedrohten Zone durch rechtzeitige und angemessene Informationen warnen.",
  "Resp-CS-02_desc":
    "Informationen über die Katastrophe an die Gesellschaft, einschließlich Freiwilligenmanagement und Spendenaufrufe.",
  "Resp-SF-01_desc":
    "Kontrollierte Evakuierung von Personen und Tieren aus einem bestimmten Gebiet oder Gebäude.",
  "Resp-SF-02_desc":
    "Unterkunft für Evakuierte, einschließlich Ernährung und Sanitär.",
  "Resp-SF-03_desc": "Zusammenführung von Evakuierten mit ihren Angehörigen.",
  "Resp-DA-01_desc":
    "Entfernung von Trümmern und/oder kontaminiertem Material.",
  "Resp-DA-02_desc":
    "Dekontamination von kontaminierten Gebieten, Infrastrukturen und/oder Fahrzeugen.",
  "Resp-DA-03_desc":
    "Entwässerung und Abpumpen von überfluteten Gebieten oder Infrastrukturen.",
  "Resp-DA-04_desc": "Vernichtung von möglicherweise infizierten Tieren.",
  "Resp-BN-01_desc":
    "Wiederherstellung oder vorübergehende Bereitstellung von Trinkwasser.",
  "Resp-BN-02_desc": "Vorübergehende Nahrungsversorgung.",
  "Resp-BN-03_desc":
    "Wiederherstellung der Strom-/Gasversorgung oder Bereitstellung vorübergehender alternativer Energie.",
  "Resp-BN-04_desc":
    "Wiederherstellung oder vorübergehende Versorgung mit IKT und Telekommunikation.",
  "Resp-BN-05_desc":
    "Sanitäranlagen wiederherstellen oder vorübergehende Lösungen bereitstellen.",
  "Resp-RS-01_desc":
    "Entscheidungsfindung, Planung und Aufgabenstellung auf Koordinierungs- und Führungsebene beim Katastrophenmanagement.",
  "Resp-RS-02_desc":
    "Entwicklung operativer Informationen durch Anreicherung gesammelter Daten, einschließlich gemeinsames Lagebild.",
  "Resp-RS-03_desc":
    "Speicherung und Weitergabe von Informationen wie gesammelten Daten, Bewertungen und getroffenen Entscheidungen.",
  "Resp-RS-04_desc":
    "Erfassung von Daten durch physische Überwachung (Surveillance) und Data-Mining.",
  "Resp-RS-05_desc":
    "Bereitstellung von Basisdiensten für Ersthelfer vor Ort zur Ermöglichung von Reaktionsaktivitäten.",
  "Resp-RS-06_desc":
    "Transport von Personal und Material zur Unterstützung anhaltender Katastrophenreaktionsoperationen.",
  "Rec-HR-01_desc":
    "Bereitstellung von öffentlichen Gesundheits- und Sicherheitsdiensten für Vertriebene.",
  "Rec-HR-02_desc":
    "Bereitstellung von Nahrung und Unterkunft für Vertriebene.",
  "Rec-ER-01_desc":
    "Beseitigung großflächiger Verschmutzung und Dekontamination sowie Abfallentsorgung.",
  "Rec-ER-02_desc": "Wiederherstellung natürlicher Ressourcen und Lebensräume.",
  "Rec-EC-01_desc":
    "Wirtschaftliche Erholung von Geschäften und Industrie, die durch die Katastrophe betroffen waren.",
  "Rec-EC-02_desc": "Erholung von den finanziellen Auswirkungen auf Behörden.",
  "Rec-RI-01_desc":
    "Wiederherstellung von Transportwegen (Straße, Schiene, Wasser, Luft, Pipelines).",
  "Rec-RI-02_desc":
    "Wiederherstellung unterbrochener Versorgungsleistungen und anderer wesentlicher Dienste.",
  "Rec-RS-01_desc":
    "Aufbau der Erholungsorganisationsstruktur für kurzfristige und langfristige Erholung.",
  "Rec-RS-02_desc":
    "Bestimmung und Umsetzung des Erholungsprogramms auf Basis der Folgenabschätzung.",
  manage_capabilities: "Fähigkeiten auswählen",
  select_capabilities_instr:
    "Wählen Sie die Fähigkeiten aus, die Sie auf Lücken bewerten möchten.",
  drawer_hazards: "Gefahren",
  drawer_gaps: "Lücken",
  drawer_solutions: "Lösungen",
  drawer_roadmap: "Fahrplan",
  drawer_capabilities: "Fähigkeiten",
  drawer_solution: "Lösung",
  drawer_with_gaps: "mit Lücken",
  drawer_no_linked_caps: "Keine verknüpften Fähigkeiten",
  drawer_add_to_roadmap: "Zum Fahrplan hinzufügen →",
  drawer_go_to_solutions: "Zu Lösungen →",
  drawer_go_to_roadmap: "Zum Fahrplan →",
  drawer_none: "Keine",
  drawer_relevant_hazards: "Relevante Gefahren",
  action_priority: "Aktionspriorität",
  action_priority_instr:
    "Bewerten Sie Ihre Bereitschaft, diese Fähigkeit zu verbessern (1 = niedrig, 5 = dringend)",
  action_priority_label_1: "Nicht jetzt",
  action_priority_label_3: "Vielleicht",
  action_priority_label_5: "Dringend",
  prev_cap: "Zurück",
  next_cap: "Weiter",
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

Die DASF-Toolsammlung unterstützt den systematischen Bewertungs- und Screening-Prozess für das Katastrophenmanagement. Sie bietet einen strukturierten Ansatz in 4 Schritten:

1. **Initiierung & Vorbereitung (I&V)**: Identifizieren Sie relevante Gefahrentypen und definieren Sie den Bewertungsumfang.
2. **Bedarfs- & Lückenbewertung (BLB)**: Bewerten Sie Fähigkeiten im Katastrophenmanagement-Zyklus, identifizieren Sie Lücken und Verbesserungsbedarfe.
3. **Lösungsbewertung (LB)**: Evaluieren Sie potenzielle Lösungen für identifizierte Fähigkeitslücken, einschließlich Compliance, Benutzeranforderungen und Auswirkungsbewertung.
4. **Roadmapping (RM)**: Planen Sie Implementierungszeitpläne und Verpflichtungen für ausgewählte Lösungen.

##### Erste Schritte

- Erstellen oder öffnen Sie eine Bewertungssitzung von der Startseite
- Navigieren Sie durch die 4 Schritte mit den Symbolleistensymbolen
- Wechseln Sie zwischen Benutzer- und Editor-Rollen mit dem Selector unten

##### Rollen

- **Normaler Benutzer**: Kann Bewertungen ausfüllen und Ergebnisse anzeigen
- **Moderator**: Kann die Framework-Konfiguration bearbeiten (Gefahrentypen, Fähigkeiten, Stakeholder)
- **Administrator**: Kann Bewertungsskalen und Einstellungen ändern

##### Hintergrund

Dieses Projekt wurde aus dem Horizon-2020-Programm der Europäischen Union für Forschung und Innovation finanziert. Entwickelt von TNO als Teil des [DIREKTION](https://www.direktion-network.org)-Projekts.`,

  // ── Collaboration (EN fallback) ────────────────────────────────────────────
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  FACILITATOR: "Facilitator",
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Fertig - Ergebnisse senden",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
};
